import React, { useState } from 'react';
import { Button, Card, Popconfirm, Space, Typography, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';

const { Title, Text } = Typography;

export default function MobileRestartGateway() {
  const navigate = useNavigate();
  const [loadingAction, setLoadingAction] = useState('');

  const runRestart = async (endpoint, successMsg) => {
    setLoadingAction(endpoint);
    try {
      const response = await api.post(endpoint);
      if (response.data.success) {
        message.success(response.data.message || successMsg);
      } else {
        message.error('重启失败');
      }
    } catch (error) {
      console.error('重启失败:', error);
      const errorMessage = error.response?.data?.detail || '重启失败，请检查网络连接';
      message.error(errorMessage);
    } finally {
      setLoadingAction('');
    }
  };

  const confirmText = '确认执行重启操作吗？重启期间IB连接会暂时中断。';

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 16px 12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, color: '#fff', fontWeight: 600 }}>
            重启IB Gateway
          </Title>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="small"
              onClick={() => navigate('/permissions', { replace: true })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              返回
            </Button>
            <Button
              size="small"
              onClick={() => navigate('/', { replace: true })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              首页
            </Button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '20px 16px 16px' }}>
        <Card style={{ borderRadius: 10, marginBottom: 16 }} styles={{ body: { padding: 20 } }}>
          <Title level={5} style={{ marginBottom: 16, textAlign: 'center' }}>
            重启IB Gateway服务
          </Title>
          <Text style={{ display: 'block', marginBottom: 24, color: '#666', textAlign: 'center', lineHeight: 1.6 }}>点击下方按钮将重启IB Gateway服务。请按需选择重启单个账户或重启全部账户。</Text>

          <Space direction="vertical" style={{ width: '100%' }} size={12}>
            <Popconfirm title="确认重启" description={confirmText} okText="确认" cancelText="取消" onConfirm={() => runRestart('/admin/restart-gateway-gyt', 'IB_GYT 重启命令已发送')}>
              <Button
                type="primary"
                size="large"
                icon={<ReloadOutlined />}
                loading={loadingAction === '/admin/restart-gateway-gyt'}
                block
                style={{
                  height: '48px',
                  fontSize: '16px',
                  borderRadius: '8px',
                }}
              >
                {loadingAction === '/admin/restart-gateway-gyt' ? '重启中...' : '重启IB_GYT'}
              </Button>
            </Popconfirm>

            <Popconfirm title="确认重启" description={confirmText} okText="确认" cancelText="取消" onConfirm={() => runRestart('/admin/restart-gateway-gil', 'IB_GIL 重启命令已发送')}>
              <Button
                type="primary"
                size="large"
                icon={<ReloadOutlined />}
                loading={loadingAction === '/admin/restart-gateway-gil'}
                block
                style={{
                  height: '48px',
                  fontSize: '16px',
                  borderRadius: '8px',
                }}
              >
                {loadingAction === '/admin/restart-gateway-gil' ? '重启中...' : '重启IB_GIL'}
              </Button>
            </Popconfirm>

            <Popconfirm title="确认重启" description={confirmText} okText="确认" cancelText="取消" onConfirm={() => runRestart('/admin/restart-gateway', '重启所有IB账户命令已发送')}>
              <Button
                size="large"
                icon={<ReloadOutlined />}
                loading={loadingAction === '/admin/restart-gateway'}
                block
                style={{
                  height: '48px',
                  fontSize: '16px',
                  borderRadius: '8px',
                }}
              >
                {loadingAction === '/admin/restart-gateway' ? '重启中...' : '重启所有IB账户'}
              </Button>
            </Popconfirm>
          </Space>
        </Card>

        <Card style={{ borderRadius: 10 }} styles={{ body: { padding: 16 } }}>
          <Text type="secondary" style={{ fontSize: 12, lineHeight: 1.5 }}>
            <strong>注意事项：</strong>
            <br />
            • 重启过程可能需要30秒左右
            <br />
            • 重启期间IB连接会暂时中断
            <br />• 请确保在合适的时间进行重启操作
          </Text>
        </Card>
      </div>
    </div>
  );
}
